import type { ChoiceOption, Questionnaire, WordStat } from '../types/questionnaire'

export const tasteOptions: ChoiceOption[] = [
  { code: 'sweet', label: '甜甜的', featured: true, color: '#ffa56f' },
  { code: 'sour', label: '酸酸的', featured: true, color: '#f3869f' },
  { code: 'bitter', label: '苦苦的', featured: true, color: '#ffcb45' },
  { code: 'spicy', label: '辣辣的', featured: true, color: '#cccc69' },
  { code: 'salty', label: '咸咸的', featured: true, color: '#adc2e4' },
  { code: 'umami', label: '鲜鲜的', featured: true, color: '#91ad95' },
  { code: 'plain', label: '淡淡的', featured: true, color: '#f4869e' },
  { code: 'rich', label: '浓郁的', featured: true, color: '#afbfe4' },
  { code: 'fresh', label: '清爽的', featured: true, color: '#e9b9c9' },
  { code: 'warm', label: '暖暖的', color: '#e6b992' },
  { code: 'fluffy', label: '绵绵的', color: '#a9d1d8' },
  { code: 'glutinous', label: '软糯的', color: '#f1d9bb' },
  { code: 'crisp', label: '酥酥的', color: '#f6d150' },
  { code: 'crunchy', label: '脆脆的', color: '#f8a176' },
  { code: 'silky', label: '丝滑的', color: '#f1c0c8' },
  { code: 'aftertaste', label: '回甘的', color: '#a0b5e2' },
  { code: 'bracing', label: '清冽的', color: '#b2c3e5' },
  { code: 'smoky', label: '烟熏的', color: '#cfe2d7' },
  { code: 'mellow', label: '醇厚的', color: '#adc8e5' },
  { code: 'fruity', label: '果香的', color: '#f8c1c9' },
  { code: 'milky', label: '奶香的', color: '#e7c99c' },
  { code: 'tea', label: '茶香的', color: '#a9d7d9' },
  { code: 'toasted', label: '焦香的', color: '#f4d169' },
  { code: 'aromatic_spice', label: '辛香的', color: '#f6b89f' },
  { code: 'floral', label: '花香的', color: '#ddd0ef' },
  { code: 'herbal', label: '草本的', color: '#cae5bd' },
  { code: 'cool', label: '凉凉的', color: '#b9d9ef' },
]

export const memoryOptions: ChoiceOption[] = [
  { code: 'childhood', label: '童年', featured: true, color: '#f0d9bb' },
  { code: 'family', label: '家人', featured: true, color: '#f0c8a7' },
  { code: 'friends', label: '朋友', featured: true, color: '#eea1a6' },
  { code: 'campus', label: '校园', featured: true, color: '#ead2d9' },
  { code: 'travel', label: '旅行', featured: true, color: '#c7e0e2' },
  { code: 'festival', label: '节日', featured: true, color: '#a8d2dc' },
  { code: 'hometown', label: '家乡', featured: true, color: '#f2cb4e' },
  { code: 'love', label: '爱情', featured: true, color: '#f4b1c3' },
  { code: 'work', label: '工作', featured: true, color: '#abc1e1' },
]

export const mockQuestionnaire: Questionnaire = {
  id: 'taste-memory',
  name: '味觉记忆互动体验',
  version: 1,
  steps: [
    {
      code: 'taste-step',
      eyebrow: '问题 1/2',
      title: '如果今天的您是一种味道，它会是什么？',
      description: '选择一个最接近您今天感受的味道吧',
      questions: [
        {
          code: 'taste',
          type: 'single_choice',
          title: '味觉选择',
          required: true,
          config: {
            allowCustom: true,
            customLabel: '写下属于您的味道',
            customMaxLength: 12,
          },
          options: tasteOptions,
        },
      ],
    },
    {
      code: 'memory-step',
      eyebrow: '问题 2/2',
      title: '您选择的味道最容易让您想起哪一段记忆？',
      description: '请描述一下这段记忆，并为它选择一个最恰当的标签吧',
      questions: [
        {
          code: 'memory_text',
          type: 'short_text',
          title: '请输入您的回忆',
          required: true,
          config: {
            placeholder: '例如：奶奶做的红烧肉 / 放学后的冰汽水',
            maxLength: 20,
          },
        },
        {
          code: 'memory_category',
          type: 'single_choice',
          title: '为这段记忆选择一个标签',
          required: true,
          config: {
            allowCustom: true,
            customLabel: '写下这个记忆的标签',
            customMaxLength: 8,
          },
          options: memoryOptions,
        },
      ],
    },
  ],
}

export const initialWordStats: WordStat[] = tasteOptions.map((option, index) => ({
  code: option.code,
  label: option.label,
  count: Math.max(1, 22 - index),
}))

export const initialMemoryStats: WordStat[] = memoryOptions.map((option, index) => ({
  code: option.code,
  label: option.label,
  count: Math.max(3, 17 - index),
}))
